import React from 'react';
import PropTypes from 'prop-types';
import SelectCampaignType from '../containers/SelectCampaignType';
import SelectPromotion from '../containers/SelectPromotion';
import AddPromo from '../containers/AddPromo';
import SelectMessageType from '../containers/SelectMessageType';
import SelectAudience from '../containers/SelectAudience';
import EmailPreview from '../containers/EmailPreview';
import PushNotificationPreview from '../containers/PushNotificationPreview';
import Logo from '../containers/Logo';
import BackgroundImage from '../containers/BackgroundImage';
import ColorPicker from '../containers/ColorPicker';
import { t } from '../../../modules/infra/i18n';

const CampaignDraft = ({ showPushPreview }) => (
  <div className="u-p+">
    <div className="layout">
      <div className="layout__item u-2/5-extralarge-and-up u-1/2-extra-extralarge-and-up u-mb">
        <SelectCampaignType />
        <div className="u-mt+">
          <SelectPromotion />
        </div>
        <div className="u-mt+">
          <AddPromo />
        </div>
        <hr className="c-separator u-mt+ u-mb" />
        <SelectMessageType />
        <hr className="c-separator u-mt+ u-mb" />
        <SelectAudience />
      </div>
      <div className="layout__item u-3/5-extralarge-and-up u-1/2-extra-extralarge-and-up">
        <hr className="c-separator u-mv u-hidden-for-extralarge-and-up" />
        <h2 className="c-heading u-mb-">{t('engage:sections.design_campaign')}</h2>
        <div className="layout layout--rev">
          <div className="layout__item u-1/3-medium-and-up">
            <PushNotificationPreview display-if={showPushPreview} />
            <div>
              <hr className="c-separator u-mv" display-if={showPushPreview} />
              <Logo />
              <div className="u-mt">
                <BackgroundImage />
              </div>
              <div className="u-mt">
                <ColorPicker />
              </div>
            </div>
          </div>
          <div className="layout__item u-2/3-medium-and-up">
            <EmailPreview />
          </div>
        </div>
      </div>
    </div>
  </div>
);
CampaignDraft.propTypes = {
  showPushPreview: PropTypes.bool.isRequired,
};

export default CampaignDraft;
